<div class="container mt-3">
  <div class="row mb-2">
    <div class="p-0" [ngClass]="{'col-4': !somenteTemperatura, 'col-12': somenteTemperatura}"
      *ngFor="let info of informacoesRoteiro"
      [style.cursor]="info.titulo === 'Temp. Carga' ? 'pointer' : null"
      (click)="abrirTemperaturaCarga(info)">
      <p class="titulo mb-0">{{ info.titulo }}</p>
      <p class="sub-titulo mb-0" style="max-lines: 2" 
         [ngClass]="{'alerta-temperatura': info.titulo === 'Temp. Carga' && tempMaxPermitidaAtiva && tempMaxPermitida <= info.valor.replace('°', '')}"
         >{{ info.valor }}</p> 
       
    </div>
  </div>
</div>
